<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">

			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="80px" :rules="rules">
				<el-row>

					<el-row>
						<el-col :span="8">
							<el-form-item label="姓名" prop="name">
								<el-input v-model="formParameter.name" autocomplete="off">
								</el-input>
							</el-form-item>
						</el-col>

						<el-col :span="8">
							<el-form-item label="手机" prop="moblie"><el-input v-model="formParameter.moblie"
									autocomplete="off"></el-input></el-form-item>
						</el-col>

						<el-col :span="8">
							<el-form-item label="民族" prop="mz">
								<el-select v-model="formParameter.mz" placeholder="请选择" filterable>
									<el-option v-for="item in nations" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>

						<el-col :span="8">
							<el-form-item label="身份证" prop="idno"><el-input v-model="formParameter.idno"
									autocomplete="off"></el-input></el-form-item>
						</el-col>
						
						<el-col :span="8">
						<el-form-item label="性别:" prop="sex">
							<select-option-dictionary v-model="formParameter.sex"
								dkey="sex"></select-option-dictionary>
						</el-form-item>
					</el-col>

						

					</el-row>
				</el-row>



				<el-row>
					<el-col :span="8">
						<el-form-item label="推荐人" prop="tjr">
							<el-select v-model="formParameter.tjr" placeholder="请选择" filterable >
								<el-option v-for="(item, idexd) in tjrmbl" :key="idexd" :label="item.name"
									:value="item.name" >

								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="推荐手机" prop="tjrmbl"><el-input @change="changeMoblie"
								v-model="formParameter.tjrmbl" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="邮箱" prop="email"><el-input v-model="formParameter.email"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-row>

						<el-col :span="12">
							<el-form-item label="开户行" prop="bank"><el-input v-model="formParameter.bank"
									autocomplete="off"></el-input></el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="银行卡号" prop="card"><el-input v-model="formParameter.card"
									autocomplete="off"></el-input></el-form-item>
						</el-col>


					</el-row>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="备注" prop="remarks"><el-input type="textarea" v-model="formParameter.remarks"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
			</el-form>

			<el-tree :data="formParameters" :props="defaultProps" :default-expand-all="true"	 ></el-tree>

		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()" v-has-permission-code-and="'003000350015'">确 定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/xueli/xlstudent.js';
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
export default {
	name: 'edit',
	components: {
		popup,
		selectOptionDictionary
	},
	data() {
		return {
			tableData: [{
				name: '',
				phone: ""
			}],
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: {},
			formParameters: [],
			tjrmbl: '',//推荐人
			defaultProps: {
				children: 'children',
				label: 'name'
			},
			nations: [
				"汉族",
				"蒙古族",
				"回族",
				"藏族",
				"维吾尔族",
				"苗族",
				"彝族",
				"壮族",
				"布依族",
				"朝鲜族",
				"满族",
				"侗族",
				"瑶族",
				"白族",
				"土家族",
				"哈尼族",
				"哈萨克族",
				"傣族",
				"黎族",
				"傈僳族",
				"佤族",
				"畲族",
				"高山族",
				"拉祜族",
				"水族",
				"东乡族",
				"纳西族",
				"景颇族",
				"柯尔克孜族",
				"土族",
				"达斡尔族",
				"仫佬族",
				"羌族",
				"布朗族",
				"撒拉族",
				"毛南族",
				"仡佬族",
				"锡伯族",
				"阿昌族",
				"普米族",
				"塔吉克族",
				"怒族",
				"乌孜别克族",
				"俄罗斯族",
				"鄂温克族",
				"德昂族",
				"保安族",
				"裕固族",
				"京族",
				"塔塔尔族",
				"独龙族",
				"鄂伦春族",
				"赫哲族",
				"门巴族",
				"珞巴族",
				"基诺族",
			],
			rules: {
				//姓名
				name: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//手机
				moblie: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 50,
						trigger: 'blur'
					}
				],
				//身份证号
				idno: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//性别
				sex: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				tjrmbl: [
					{ validator: this.validDh, message: '请输入正确的手机号格式', trigger: 'blur' }
				],
				//民族
				mz: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				]

			}
		};
	},
	methods: {


		//打开弹框
		open(parameter, title, disabled, size) {
			this.parameter = parameter;
			this.disabled = disabled;
			this.formParameters= []
			this.list()
			console.log("this.disabled", this.disabled)
			this.$refs.popup.open(title, size);

			this.$nextTick(() => {
				this.init();
			})
		},
		//关闭弹框
		close() {
			this.disabled = false;
			this.$refs.popup.close();
		},
		//获取数据
		list() {
			api.list({}, response => {
				this.tjrmbl = response.data.records;
				console.log('this.listData', this.tjrmbl);
			})
		},
		//提交表单
		confirm() {
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;
				if (!this.parameter.id) {
					//添加
					let parameter = this.$utils.merger(this.formParameter);
					console.log('parameter', parameter);
					api.save(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				} else {
					//编辑
					let parameter = this.$utils.merger(this.formParameter);
					api.update(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				}
			});
		},
		changeMoblie() {
			console.log(this.formParameter.tjrmbl)
			let a = this.formParameter;
			//  a.tjr = "邓玉杰"
			this.$set(this.formParameter, a);

		},
		init() {
			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = {};
			//清楚校验
			this.$refs.form.clearValidate();

			if (this.parameter.id) {
				//编辑查询数据
				let parameter = {
					id: this.parameter.id
				};

		 
				api.oneWithChild(parameter, response => {
					this.formParameter = response.data;
					this.formParameters = [this.formParameter]
					this.popupLoading = false;
				});
			} else {
				//添加
				this.popupLoading = false;
			}
		}
	}

};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
